/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AtelierInputs */

const en_nav_atelier = /** @type {(inputs: Nav_AtelierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atelier`)
};

/**
* | output |
* | --- |
* | "Atelier" |
*
* @param {Nav_AtelierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_atelier = /** @type {((inputs?: Nav_AtelierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AtelierInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_atelier(inputs)
});